import {Component, OnInit} from '@angular/core';
import {MessageService} from 'primeng/api';
import {ReportXpressService, ConfigService} from 'app/services';
import moment from 'moment';
import {Utils} from 'app/utils';
import {ExportFileTypeEnum} from 'app/models';
import {AppComponent} from 'app/app.component';

@Component({
	selector: 'report-taxi-driver-performance',
	templateUrl: './report-taxi-driver-performance.component.html',
	styleUrls: ['./report-taxi-driver-performance.component.scss'],
	providers: [MessageService]
})
export class ReportTaxiPerformanceComponent implements OnInit {

	constructor(
		public reportXpressService: ReportXpressService,
		public configService: ConfigService,
		public app: AppComponent,
		public messageService: MessageService
	) {
	}

	public performanceData: any[] = [];
	public selectedDateRange: Date[] = [];
	public isLoading: boolean = true;
	public exportFileTypeEnum = ExportFileTypeEnum;

	public frequencies = [
		{label: 'Daily', value: 0},
		{label: 'Weekly', value: 1},
		{label: 'Monthly', value: 2}
	];
	public selectedFrequency: number = 0;

	private searchTimer: number = 0;

	ngOnInit(): void {
		this.selectedDateRange[0] = new Date();
		this.selectedDateRange[0].setDate(new Date().getDate() - 30);
		this.selectedDateRange[1] = new Date();

		this.loadData();
	}

	public loadData() {
		if (!this.selectedDateRange || !this.selectedDateRange[1]) {return;}

		this.isLoading = true;

		const dto = {
			StartDate: moment(this.selectedDateRange[0]).format('YYYY-MM-DD'),
			EndDate: moment(this.selectedDateRange[1]).format('YYYY-MM-DD'),
			TimeZoneOffset: Utils.getTimezoneOffset(),
			Frequency: this.selectedFrequency
		};

		this.reportXpressService.getTaxiDriversPerformanceReport(dto, this.messageService)
			.then(data => {
				if (data.Success) {
					this.performanceData = data.Items;
				} else {
					this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
				}
				this.isLoading = false;
			})
			.catch(err => {
				this.isLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load taxi performance report' });
			});
	}

	public exportData(fileType: ExportFileTypeEnum) {
		if (!this.selectedDateRange || !this.selectedDateRange[1]) {
			return;
		}

		this.isLoading = true;

		const dto = {
			StartDate: moment(this.selectedDateRange[0]).format('YYYY-MM-DD'),
			EndDate: moment(this.selectedDateRange[1]).format('YYYY-MM-DD'),
			FileType: fileType,
			TimeZoneOffset: Utils.getTimezoneOffset(),
			Frequency: this.selectedFrequency
		};

		this.reportXpressService.exportTaxiDriversPerformanceReport(dto, this.messageService)
			.then(data => {
				this.messageService.add({severity: 'success', summary: 'Success', detail: 'Export completed'});
				const freqLabel = this.frequencies.find(f => f.value === this.selectedFrequency)?.label || 'Report';
				Utils.saveFileResponse(data, `Taxi_Performance_${freqLabel}_${moment().format('YYYYMMDD')}`, fileType);
				this.isLoading = false;
			})
			.catch(err => {
				this.isLoading = false;
				this.messageService.add({severity: 'error', summary: 'Error', detail: 'Export failed'});
			});
	}

	public onFilterChange() {
		if (this.searchTimer) {clearTimeout(this.searchTimer);}
		this.searchTimer = window.setTimeout(() => {
			this.loadData();
		}, 1000);
	}
}
